export { default } from './InspectorWrapper';
